import { IonContent, IonHeader, IonPage, IonSpinner, IonTitle, IonToolbar } from '@ionic/react'
import React, { Suspense } from 'react'
import MyMessages from '../../components/MyMessages'
import Api from '../../services/Api'

const Conversations = () => {
  const api = Api.getInstance()
  
  return (
    <IonPage className="cheap_desktop">
      <IonHeader>
        <IonToolbar>
          <IonTitle>
            { api.tr('chat_page')}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <Suspense fallback={<IonSpinner/>}>
          <MyMessages/>
        </Suspense>
      </IonContent>
    </IonPage>
  )
}
export default Conversations